import Vue from 'vue'
import Index from './index.vue'
import router from '@/router/router'
const Constructor = Vue.extend(Index)

let instance = null;
let init = () => {
  Index.install = (data => {
    instance = new Constructor({
      data
    }).$mount();
    document.body.appendChild(instance.$el);
  })();
};
let detail = opts => {
  // console.log('detail_opts: ', opts);
  // if (!instance) {
  //   init(opts);
  // }
  init(opts);
  Vue.nextTick(() => {
    // console.log('detail_nextTick: ', opts)
    instance.open(opts);
  });
};

router.afterEach((to, from) => {
  if(instance) {
    instance.handleClose()
    instance.closeDialog();
    instance.closePro();
  }
})

export default {
  install: Vue => {
    Vue.prototype.$memberdetail = detail
  }
}
